import React, { useMemo } from 'react';
import GraficoPizza from 'components/GraficoPizza';
import { montarGraficoPizzaStatus } from './relatorioResumido';
import moment from 'moment/moment';

export default function StatusResumido({ dadosGrafico, filtroSelecionado }) {
  const title = useMemo(() => {
    return `Período ${moment(filtroSelecionado?.DataInicio).format('DD/MM/YYYY')} - ${moment(
      filtroSelecionado?.DataFim
    ).format('DD/MM/YYYY')}`;
  }, [filtroSelecionado]);

  return (
    <>
      {dadosGrafico?.map(periodo => {
        return (
          <GraficoPizza
            key={periodo.id}
            dados={montarGraficoPizzaStatus(periodo)}
            height={'550px'}
            width={'750px'}
            margin={'0px auto auto auto'}
            title={title}
            exportar={true}
          />
        );
      })}
    </>
  );
}
